import React, { Component } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { localize } from '../../../../util/Localizer'
import NoResultsMsg from '../../../../widgets/common/NoResultsMsg'

class Copay extends Component {
  render () {
    let copayArray = this.props.data
    return (
      <div className='coinsurance'>
        {copayArray.length > 0 ? (
          <Row>
            <Col>
              <ul className='bulletedList'>
                {copayArray.map((item, i) => { return <li key={i}>{item.description}</li> })}
              </ul>
            </Col>
          </Row>
        ) : (
          <NoResultsMsg message={localize('pages.benefitDetails.copay.empty')} />
        )}
      </div>
    )
  }
}

export default Copay



// WEBPACK FOOTER //
// ./src/widgets/Member/benefitsWidgets/commonDetails/Copay.js